import './style.sass'
import buildField from './game.js'

const SCREEN_CELL = 32;

function fitScreen() {
    const cols = Math.floor((innerWidth - 20) / SCREEN_CELL);
    const rows = Math.floor((innerHeight - 60) / SCREEN_CELL);
    return [cols, rows, Math.round(cols * rows * .2)];
}

const grades = {
    1: () => [9, 9, 10],
    2: () => [16, 16, 40],
    3: () => [30, 16, 99],
    4: fitScreen,
};

const gradeInputs = [...document.querySelectorAll('#settings input[name="settings-grade"]')];
const savedGrade = gradeInputs.find(input => input.value === localStorage.getItem('diff')) ?? gradeInputs[0];

function newGame() {
    const grade = gradeInputs.find(input => input.checked).value;
    localStorage.setItem('diff', grade);
    document.documentElement.dataset.mobile = grade === '4';
    buildField(...grades[grade]());
}

gradeInputs.forEach(input => input.addEventListener('click', newGame));
document.querySelector('#reset-btn').addEventListener('click', newGame);
savedGrade.click();
